import { CALL_API, getJSON } from 'redux-api-middleware';
import { normalize } from 'normalizr';
import { products } from 'schemas';
import endpoints from 'api/endpoints';
import types from '../types';

export default productId => ({
  [CALL_API]: {
    endpoint: endpoints.PRODUCT_API.replace(':productId', productId),
    method: 'GET',

    types: [
      types.GET_PRODUCT_REQUEST,

      {
        type: types.GET_PRODUCT_SUCCESS,
        payload: (action, state, res) => getJSON(res)
          .then(json => normalize(
            json,
            products.productSchema,
          )),
      },

      types.GET_PRODUCT_FAILURE,
    ],
  },
});



// WEBPACK FOOTER //
// ./src/api/products/actions/getProduct.js